import {
  selectEntitiesBetsEntityCurrentTotal,
  selectEntitiesBetsEntityMarketTotal,
} from '../../selectors/entities/bets/entitiesBetsPrimary.selector';
import {
  selectEntitiesOutcomesEntityBetId,
  selectEntitiesOutcomesEntityCode,
} from '../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { selectHistoryOutcomeStatusFromOutcomeId } from '../../selectors/history.selector';
import { StateType } from '../../states';
import { OutcomeEntity } from '../../states/entities/outcomes';
import { Selector } from '../../types/selectors';
import { createResultEqualSelector } from '../../utils/reselect';

type SelectHistoryItemOutcomeCardProgressBarProps = {
  outcomeId?: number;
};

const makeHistoryItemOutcomeCardProgressBarSelector = () => {
  const selectThreshold = (state: StateType, props?: SelectHistoryItemOutcomeCardProgressBarProps) => {
    const betId = selectEntitiesOutcomesEntityBetId(state, props);

    if (betId) {
      return selectEntitiesBetsEntityMarketTotal(state, { betId });
    }
  };

  const selectCurrentValue = (state: StateType, props?: SelectHistoryItemOutcomeCardProgressBarProps) => {
    const betId = selectEntitiesOutcomesEntityBetId(state, props);

    if (betId) {
      return selectEntitiesBetsEntityCurrentTotal(state, { betId });
    }
  };

  const selectIsVisible = (state: StateType, props?: SelectHistoryItemOutcomeCardProgressBarProps) => {
    const outcomeCode = selectEntitiesOutcomesEntityCode(state, props);

    if (outcomeCode) {
      return OutcomeEntity.isCodeOverUnder(outcomeCode);
    }

    return false;
  };

  type SelectorType = {
    threshold: ReturnType<typeof selectThreshold>;
    currentValue: ReturnType<typeof selectCurrentValue>;
    isVisible: ReturnType<typeof selectIsVisible>;
    status: ReturnType<typeof selectHistoryOutcomeStatusFromOutcomeId>;
  };

  const selector: Selector<SelectorType> = createResultEqualSelector(
    [selectThreshold, selectCurrentValue, selectIsVisible, selectHistoryOutcomeStatusFromOutcomeId],
    (threshold, currentValue, isVisible, status) => ({
      threshold,
      currentValue,
      isVisible,
      status,
    }),
  );

  return selector;
};

export default makeHistoryItemOutcomeCardProgressBarSelector;
